module.exports = __webpack_public_path__ + "img/05_sub_no.cde72343.svg";